import { Dispatch, Action } from 'redux';
import { ThunkAction } from "redux-thunk";
import { ApplicationState } from '../index';
import { LayoutActionTypes } from './types';
import { changeHTMLAttribute } from '../../Components/Common/ThemeSettings/themeutitlity';

export type AppThunk = ThunkAction<void, ApplicationState, null, Action<string>>;

export const changeLayout = (layout: string): AppThunk => async (dispatch: Dispatch) => {
    if (layout === 'twocolumn') {
        document.documentElement.removeAttribute('data-layout-width');
    } else if (layout === 'horizontal') {
        document.documentElement.removeAttribute('data-sidebar-size');
    } else if (layout === 'semibox') {
        changeHTMLAttribute('data-layout-width', 'fluid');
        changeHTMLAttribute('data-layout-style', 'default');
    }
    changeHTMLAttribute('data-layout', layout);
    dispatch({ type: LayoutActionTypes.CHANGE_LAYOUT, payload: layout });
};

export const changeLayoutMode = (mode: string): AppThunk => async (dispatch: Dispatch) => {
    changeHTMLAttribute('data-bs-theme', mode);
    dispatch({ type: LayoutActionTypes.CHANGE_LAYOUT_MODE, payload: mode });
};

export const changeSidebarTheme = (theme: string): AppThunk => async (dispatch: Dispatch) => {
    changeHTMLAttribute('data-sidebar', theme);
    dispatch({ type: LayoutActionTypes.CHANGE_SIDEBAR_THEME, payload: theme });
};

export const changeLayoutWidth = (layoutWidth: any) => async (dispatch: any) => {
    try {
        if (layoutWidth === 'lg') {
            changeHTMLAttribute("data-layout-width", "fluid");
        } else {
            changeHTMLAttribute("data-layout-width", "boxed");
        }
        dispatch({ type: LayoutActionTypes.CHANGE_LAYOUT_WIDTH, payload: layoutWidth });
    } catch (error) {
        return error;
    }
};


export const changeLayoutPosition = (layoutposition: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-layout-position", layoutposition);
        dispatch({ type: LayoutActionTypes.CHANGE_LAYOUT_POSITION, payload: layoutposition });
    } catch (error) {
    }
};


export const changeTopbarTheme = (topbarTheme: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-topbar", topbarTheme);
        dispatch({ type: LayoutActionTypes.CHANGE_TOPBAR_THEME, payload: topbarTheme });

    } catch (error) {
    }
};

export const changeSidebarImageType = (leftsidebarImagetype: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-sidebar-image", leftsidebarImagetype);
        dispatch({ type: LayoutActionTypes.CHANGE_SIDEBAR_IMAGE, payload: leftsidebarImagetype });
    } catch (error) {
    }
};


export const changePreLoader = (preloaderTypes: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-preloader", preloaderTypes);
        dispatch({ type: LayoutActionTypes.CHANGE_PRELOADER, payload: preloaderTypes });
    } catch (error) {
    }
};


export const changeLeftsidebarSizeType = (leftsidebarSizetype: any) => async (dispatch: any) => {
    try {
        switch (leftsidebarSizetype) {
            case 'lg':
                changeHTMLAttribute("data-sidebar-size", "lg");
                break;
            case 'md':
                changeHTMLAttribute("data-sidebar-size", "md");
                break;
            case "sm":
                changeHTMLAttribute("data-sidebar-size", "sm");
                break;
            case "sm-hover":
                changeHTMLAttribute("data-sidebar-size", "sm-hover");
                break;
            default:
                changeHTMLAttribute("data-sidebar-size", "lg");
        }
        dispatch({ type: LayoutActionTypes.CHANGE_LEFTSIDEBAR_SIZE, payload: leftsidebarSizetype });

    } catch (error) {
    }
};

export const changeLeftsidebarViewType = (leftsidebarViewtype: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-layout-style", leftsidebarViewtype);
        dispatch({ type: LayoutActionTypes.CHANGE_LEFTSIDEBAR_VIEW, payload: leftsidebarViewtype });
    } catch (error) {
    }
};


export const changeSidebarVisibility = (sidebarVisibilitytype: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-sidebar-visibility", sidebarVisibilitytype);
        dispatch({ type: LayoutActionTypes.CHANGE_SIDEBAR_VISIBILITY, payload: sidebarVisibilitytype });
    } catch (error) { }
};

export const changeThemePrimary = (themeprimary: any) => async (dispatch: any) => { 
    try {
        changeHTMLAttribute("data-theme-primary", themeprimary);
        dispatch({ type: LayoutActionTypes.CHANGE_THEME_PRIMARY, payload: themeprimary });
    } catch (error) { }
};

export const changeThemeSecondary = (themeSecondary: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-theme-Secondary", themeSecondary);
        dispatch({ type: LayoutActionTypes.CHANGE_THEME_SECONDARY, payload: themeSecondary });
    } catch (error) { }
};

export const changeDarkLogo = (logoObj: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-theme-dark-logo", logoObj);
        dispatch({ type: LayoutActionTypes.CHANGE_DARK_LOGO, payload: logoObj });
    } catch (error) { }
};
export const changeLightLogo = (logoObj: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-theme-light-logo", logoObj);
        dispatch({ type: LayoutActionTypes.CHANGE_LIGHT_LOGO, payload: logoObj });
    } catch (error) { }
};


export const changeDarkLogoSmall = (logoObj: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-theme-dark-logo-sm", logoObj);
        dispatch({ type: LayoutActionTypes.CHANGE_DARK_LOGO_SMALL, payload: logoObj });
    } catch (error) { }
};
export const changeLightLogoSmall = (logoObj: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-theme-light-logo-sm", logoObj);
        dispatch({ type: LayoutActionTypes.CHANGE_LIGHT_LOGO_SMALL, payload: logoObj });
    } catch (error) { }
};

export const resetSetting = () => async (dispatch: any) => {
    try {
        dispatch({ type: LayoutActionTypes.CHANGE_RESET });
    } catch (error) { }
}; 
export const setTheme = (themeObj: any) => async (dispatch: any) => {
    try {
        changeHTMLAttribute("data-theme-light-logo-sm", themeObj?.light_logo_sm);
        changeHTMLAttribute("data-theme-light-logo", themeObj?.light_logo);
        changeHTMLAttribute("data-theme-dark-logo", themeObj?.dark_logo);
        changeHTMLAttribute("data-theme-dark-logo-sm", themeObj?.dark_logo_sm);

        dispatch({ type: LayoutActionTypes.CHANGE_SETTHEME , payload: themeObj });
    } catch (error) { }
}; 




